var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiInputBase-root': {
            background: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            border: '1px solid #ced4da',
            transition: theme.transitions.create(['border-color']),
            '&:focus, &:hover': {
                backgroundColor: theme.palette.background.paper,
                borderRadius: 4,
                borderColor: theme.palette.primary.main,
                transition: 0,
            },
        },
    },
    selectMasq: {
        '& .MuiInputBase-root, & .MuiInputBase-input': {
            cursor: 'pointer'
        },
    },
    borderless: {
        '& .MuiInputBase-root': {
            border: 0,
            borderRadius: 0,
        },
    },
}));
export default React.forwardRef((props, ref) => {
    const classes = useStyles();
    const { masqueradeAsSelect, InputProps } = props, textFieldProps = __rest(props, ["masqueradeAsSelect", "InputProps"]);
    const inputProps = Object.assign({ disableUnderline: true }, InputProps || {});
    const css = `${props.className || ''} ${classes.root} ` +
        ` ${props.masqueradeAsSelect ? classes.selectMasq : ''}` +
        ` ${props.borderless ? classes.borderless : ''}`;
    return React.createElement(TextField, Object.assign({}, textFieldProps, { ref: ref, variant: "filled", className: css, InputProps: inputProps }));
});
